<template>
  <div id="wrapper">
    <header class="navbar navbar-default navbar-inner">
      <div class="container">
        <nav>
          <nav-bar />
        </nav>
      </div>
    </header>

    <!-- AlertMessages displayer directive -->
    <alert-message></alert-message>
    <router-view />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
export default {
  name: "App",
  components: {
    NavBar,
  },
};
</script>